module.exports = __webpack_public_path__ + "media/fonts/themify-f0fc8c798eac5636249c4ea287832422.svg";